import { api } from './apiClient';

export interface ProductGroupListParams {
  pageNo: number;
  pageSize: number;
  search?: string;
}

export const productGroupService = {
  // 获取商品组列表
  getProductGroupList: async (params: ProductGroupListParams) => {
    return api.get('/admin/productGroup/list', { params });
  },

  // 获取商品组详情
  getProductGroupDetail: async (id: string) => {
    return api.get('/admin/productGroup/detail', { params: { id } });
  },

  // 新增商品组
  addProductGroup: async (data: any) => {
    return api.post('/admin/productGroup/save', data);
  },

  // 更新商品组
  updateProductGroup: async (data: any) => {
    return api.post('/admin/productGroup/update', data);
  },

  // 删除商品组
  deleteProductGroup: async (id: string) => {
    return api.post('/admin/productGroup/delete', null, { 
      params: { 
        id: id,
      } 
    });
  },

  // 获取商品组关联的商品列表（包含规格ID，用于提取可选规格）
  getGroupProducts: async (groupId: string) => {
    return api.get('/admin/productGroup/product/list', { 
      params: { 
        groupId
      } 
    });
  },

  // 添加商品到商品组
  addProductsToGroup: async (groupId: string, productIds: string[]) => {
    return api.post('/admin/productGroup/addProducts', { productList: productIds }, {
      params: { 
        groupId,
      }
    });
  },

  // 从商品组移除商品
  removeProductFromGroup: async (groupId: string, productId: string) => {
    return api.post('/admin/productGroup/removeProduct', null, {
      params: { 
        groupId, 
        productId,
      }
    });
  },

  // 获取商品组的可选规格列表（包含规格及其父级）
  getAvailableSpecs: async (groupId: string) => {
    return api.get('/admin/productGroup/spec/available', { 
      params: { 
        groupId
      } 
    });
  },
};
